import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=c6560b42"
import script from "./Voucher.vue?vue&type=script&lang=js"
export * from "./Voucher.vue?vue&type=script&lang=js"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=c6560b42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports